import React, { PropsWithChildren } from 'react';
import styled from '@emotion/styled';
import Grid from '@mui/material/Grid';
import LoginBackground from 'assets/images/login-background.png';

const StyledBackgroundSection = styled(Grid)`
  background-image: url(${LoginBackground});
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
`;
const StartLicenceTemplate = ({ children }: PropsWithChildren) => (
  <Grid sx={{ minHeight: '100vh', justifyContent: "center" }}>
    {children}
    <StyledBackgroundSection
      size={{ lg: 6 }}
      sx={{ display: { xs: 'none', xl: 'flex' }, flexDirection: 'column', padding: 10, justifyContent: 'space-between' }}
    />
  </Grid>
);

export { StartLicenceTemplate };
